module.exports = __webpack_public_path__ + "static/img/far1_active.8094c076.png";